import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Input } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import { Field } from "./../../../Order/Field/Field";
import Files from "./Files/Files";
import style from "./../Items.module.scss";
import { FormattedDate } from "react-intl";

const NewPost = ({ alertId, readonly, user, status, fetchs, dispatch, processes }) => {
  const [loading, setLoading] = React.useState(false);
  const [changingStatus, setChangingStatus] = React.useState(false);
  const [description, setDescription] = React.useState("");
  const [files, setFiles] = React.useState([]);
  const [errors, setErrors] = React.useState({});
  const [currentDate, setCurrentDate] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000); // Actualiza la fecha cada segundo

    return () => clearInterval(interval); // Limpia el intervalo cuando el componente se desmonta
  }, []);

  const handleFilesUpload = (event) => {
    const addedFiles = Object.values(event.target.files);

    setFiles([
      ...files,
      ...addedFiles.map((f) => ({
        id: Math.random().toString(36).substring(2, 15),
        name: f.name,
        type: f.type,
        data: f,
      })),
    ]);
  };

  const deleteFile = (id) => {
    setFiles(files.filter((f) => f.id != id));
  };

  const addToHistory = () => {
    if (description == null || description == "") {
      setErrors({
        ...errors,
        description: "Required Field",
      });
    } else {
      setLoading(true);
      // prepare files
      let filesFD = new FormData();

      files.forEach((f, i) => {
        filesFD.append(`file${i + 1}`, f.data);
      });

      const  getLocalISOTime =() =>{
        const date = new Date();
        const tzOffset = -date.getTimezoneOffset() * 60 * 1000;
        const localDate = new Date(date.getTime() + tzOffset);
        const localISOTime = localDate.toISOString().slice(0, -1);
    
        return localISOTime;
      };

    fetchs.addToHistory(
      {
        eventId: alertId,
        message: description,
        dateTime: getLocalISOTime(),
        files: filesFD,
      },
      (response) => {
        fetchs.alert(alertId);

        setLoading(false);
        setFiles([]);
        setDescription("");
      }
    );
  }
};



  const changeWorkingStatus = () => {
    let nextStatus = "WorkingAdvisor";

    if (user.role == "Advisor") {
      nextStatus = "WorkingCompliance";
    }

    setChangingStatus(true);

    fetchs.updateStatus(
      {
        eventId: alertId,
        statusCompliance: nextStatus,
      },
      (response) => {
        dispatch({ type: "ALERT_UPDATE", alert: { status: nextStatus } });
        setChangingStatus(false);
        fetchs.updateGrid(alertId);
      }
    );

    {
      user.role == "Advisor" ? "Compliance" : "Advisor";
    }
  };

  const sendToCEO = () => {
    let nextStatus = "WorkingCEO";

    if (status == "WorkingCEO") {
      nextStatus = "WorkingCompliance";
    }

    setChangingStatus(true);

    fetchs.updateStatus(
      {
        eventId: alertId,
        statusCompliance: nextStatus,
      },
      (response) => {
        dispatch({ type: "ALERT_UPDATE", alert: { status: nextStatus } });
        setChangingStatus(false);
      }
    );
  };

  if (readonly) {
    return null;
  }

  return (
    <div className={style.newpost}>
      <Container>
        <Row>
          <Col lg={5}>
            <span className={style.user}>{user.name}</span>
            <small>
              <FormattedDate value={new Date()} />
            </small>
          </Col>
          {processes != "ExternalImport" && processes != "RiskChanges" && (
            <Col lg={7}>
              {((user.role == "Advisor" && status == "WorkingAdvisor") ||
                (user.role == "Compliance" && status == "WorkingCompliance")) && (
                <LaddaButton
                  className={"btn btn-ladda btn-primary btn-sm"}
                  style={{ float: "right" }}
                  loading={changingStatus}
                  onClick={() => changeWorkingStatus()}
                  data-style={EXPAND_RIGHT}
                >
                  <i className="fa fa-paper-plane" aria-hidden="true"></i> Send to{" "}
                  {user.role == "Advisor" ? "Compliance" : "Advisor"}
                </LaddaButton>
              )}
            </Col>
          )}
        </Row>
        <div> </div>
        {processes === "TransactionalLimit" || processes === "RiskChanges" ? (
          <Row>
            <Col lg={12}>
              {((user.role == "CEO" && status == "WorkingCEO" && processes != "RiskChanges") ||
                (user.role == "Compliance" && status == "WorkingCompliance")) && (
                <LaddaButton
                  className={"btn btn-ladda btn-primary btn-sm"}
                  style={{ float: "right" }}
                  loading={changingStatus}
                  onClick={() => sendToCEO()}
                  data-style={EXPAND_RIGHT}
                >
                  <i className="fa fa-paper-plane" aria-hidden="true"></i>
                  {status == "WorkingCompliance" ? "Second Approval" : "Send to Compliance"}
                </LaddaButton>
              )}
            </Col>
          </Row>
        ) : ("")}

        <Row>
          <Col lg={12}>
            <Field label={"Description"} error={errors.description}>
            <Input
                type={"textarea"}
                rows={2}
                placeholder={"Description"}
                value={description}
                disabled={readonly || loading}
                invalid={!!errors.description || description.length > 1000}
                style={description.length > 1000 ? { borderColor: "red" } : {}}
                onChange={(e) => {
                  if (e.target.value.length <= 1000) {
                    setDescription(e.target.value);
                    if (e.target.value !== "") {
                      setErrors({ ...errors, description: undefined });
                    }
                  } else {
                    setErrors({ ...errors, description: "Max Characters Limit Reached" });
                  }
                }}
              />
            </Field>

            <Files files={files} deleteFile={deleteFile} />

            <div className="mt-2 mb-2 text-right">
              <Button color="primary btn btn-sm" style={{ float: "left", position: "relative" }}>
                <i className="fa fa-upload mr-2"></i>
                <input
                  type="file"
                  className={style.inputFile}
                  multiple
                  onChange={(e) => handleFilesUpload(e)}
                />
                Upload files
              </Button>
              <Button
                color="light btn-sm"
                onClick={() => {
                  setFiles([]);
                  setDescription("");
                  setErrors({});
                }}
              >
                Discard
              </Button>{" "}
              <LaddaButton
                className={"btn btn-ladda btn-primary btn-sm"}
                loading={loading}
                onClick={() => addToHistory()}
                data-style={EXPAND_RIGHT}
              >
                Add
              </LaddaButton>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NewPost;